import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "shadeParent",
  style: {"padding":"5px"}
}
const _hoisted_2 = { class: "container1" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { style: {"color":"white"} }
const _hoisted_5 = { class: "body" }
const _hoisted_6 = { class: "shade-name" }
const _hoisted_7 = { class: "heading" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "buttons" }
const _hoisted_10 = ["aria-label", "value"]
const _hoisted_11 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popup = _resolveComponent("Popup", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Popup, {
      anchor: 'button',
      option: _ctx.option,
      show: _ctx.show,
      "popup-class": 'popup-content',
      style: {"top":"16.5rem","left":"33rem"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("popup.addShade")), 1),
            _createElementVNode("button", {
              class: "close k-icon k-i-close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = false))
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("popup.chooseYourColor")), 1),
              _createElementVNode("input", {
                class: "shade",
                type: "text",
                id: "shade",
                "aria-label": _ctx.$t('popup.enterSahdeName'),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('input', _ctx.handleEmit($event.target))))
              }, null, 40, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("input", {
                type: "color",
                id: "favcolor",
                name: "favcolor",
                "aria-label": _ctx.$t('popup.chooseYourColor'),
                value: _ctx.hexValue,
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onInput($event)))
              }, null, 40, _hoisted_10)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-secondary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.show = false)),
              style: {"width":"70px","margin-right":"10px","border-radius":"4px","font-size":"0.9rem"}
            }, _toDisplayString(_ctx.$t("popup.close")), 1),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('handleshadeAddition', _ctx.option.name))),
              style: {"width":"150px","border-radius":"4px","font-size":"0.9rem"}
            }, _toDisplayString(_ctx.$t("popup.saveChanges")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["option", "show"]),
    _createElementVNode("button", {
      class: "plusButton btn btn-primary",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.show = true)),
      ref: "button"
    }, [...(_cache[6] || (_cache[6] = [
      _createElementVNode("i", { class: "fas fa-plus" }, null, -1)
    ]))], 512)
  ]))
}